(() => {
  if (customElements.get('bc-shopify-awards')) return;
  class BlackCometShopifyAwards extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const on = (node, type, fn) => node?.addEventListener(type, fn, { signal: this.controller.signal });
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.bc-awards__details');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.expanded = this.details.open;
      this.syncDisclosure();
      on(this.summary, 'click', event => { event.preventDefault(); this.setExpanded(!this.expanded); });
      on(this.details, 'toggle', () => {
        if (this.disclosureAnimation) return;
        this.expanded = this.details.open;
        this.syncDisclosure();
      });
      on(document, 'shopify:block:select', event => {
        const id = event.detail?.blockId;
        if (id && this.querySelector(`[data-shopify-editor-block*="${CSS.escape(id)}"]`)) this.setExpanded(true);
      });
      on(this.reduced, 'change', () => {
        this.disclosureAnimation?.cancel(); this.disclosureAnimation = null;
        this.details.open = this.expanded; this.syncDisclosure();
        if (this.reduced.matches) this.finishLaurel();
      });
      if (this.reduced.matches || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible'); this.finishLaurel();
      } else {
        this.classList.add('is-prepared'); this.dataset.laurelState = 'waiting';
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const visible = entries.some(entry => entry.isIntersecting);
          this.classList.toggle('is-motion-active', visible);
          if (visible) { this.classList.add('is-visible'); this.drawLaurel(); }
        }, { threshold: .12 });
        this.observer.observe(this);
      } else this.classList.add('is-motion-active');
    }
    drawLaurel() {
      if (this.classList.contains('is-laurel-drawn')) return;
      this.classList.add('is-laurel-drawn');
      if (this.reduced.matches) { this.finishLaurel(); return; }
      this.classList.add('is-laurel-drawing');
      this.dataset.laurelState = 'drawing';
      this.laurelTimer = setTimeout(() => this.finishLaurel(), 2150);
    }
    finishLaurel() {
      clearTimeout(this.laurelTimer);
      this.classList.add('is-laurel-drawn');
      this.classList.remove('is-laurel-drawing');
      this.dataset.laurelState = 'complete';
    }
    syncDisclosure() {
      this.summary.setAttribute('aria-expanded', String(this.expanded));
      this.content.inert = !this.expanded;
      this.content.setAttribute('aria-hidden', String(!this.expanded));
      this.dataset.expanded = String(this.expanded);
    }
    setExpanded(expanded) {
      const from = this.details.getBoundingClientRect().height;
      this.disclosureAnimation?.cancel(); this.disclosureAnimation = null;
      this.expanded = expanded; this.syncDisclosure();
      if (this.reduced.matches) { this.details.open = expanded; return; }
      this.details.open = true;
      const to = expanded ? this.details.getBoundingClientRect().height : this.summary.getBoundingClientRect().height + 2;
      const animation = this.details.animate([{ height: `${from}px` }, { height: `${to}px` }], { duration: 460, easing: 'cubic-bezier(.22,1,.36,1)' });
      this.disclosureAnimation = animation;
      animation.onfinish = () => {
        if (this.disclosureAnimation !== animation) return;
        this.details.open = this.expanded; this.disclosureAnimation = null;
      };
    }
    disconnectedCallback() {
      clearTimeout(this.laurelTimer);
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); this.observer = null;
      this.disclosureAnimation?.cancel(); this.disclosureAnimation = null;
    }
  }
  customElements.define('bc-shopify-awards', BlackCometShopifyAwards);
})();
